export const environment = {
    production: false,
    apiUrl: "https://dev2.livepick.ai/",
    AzureRedirectUri: "https://dev2.app.livepick.ai",
    google_auth_client_id: "1088177631529-2p71qppqsetlg6aospbniqh8bn72e2gf.apps.googleusercontent.com",
    generatePhotoUrl: "https://eu.ui-avatars.com/api/?background=DFD22B&color=fff&name=",
    socketUrl : "wss://dev2.livepick.ai:5678/",
    facebook_auth_client_id: "357359291637009",
  };
  